import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';
import { string } from 'prop-types';

const API_SLUG = 'Usuarios';

export interface Usuario {
	dni: string;
	login: string;
  nombre: string;
  idCP: string;
	codArea: string;
  area: string;
  perfil: string;
	nombrePerfil: string;
	email: string;
  fechaBaja: string;
  responsable: string;
  nombreResponsable: string;
  controlUsuarios: boolean;
}

export interface Perfil {
	id: string;
	nombre: string;
}

export interface UsuarioPermisos {
	dni: string;
	login: string;
  	nombre: string;
  	perfil: string;
	tienePermisos: boolean;
}

export class UsuariosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarTodosUsuarios(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarTodosUsuarios`);
	}

	ListarHorasUsuario(filtro:any): AxiosPromise<any[]> {
		return this.cliente.post(filtro,`/ListarHorasUsuario`);
	}
	
	ListarUsuariosConAdministracionExpatriados(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarUsuariosAdministracionExpatriados`);
	}

	ListarInformacionRolesExpatriados(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarInformacionRolesExpatriados`);
	}

	ListarUsuariosExpatriadosConHistoricoAdjuntos(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarUsuariosExpatriadosHistoricoAdjuntos`);
	}

	ListarUsuariosExpatriadosAjustes(filter:any): AxiosPromise<any[]> {
		return this.cliente.post(filter,`/ListarUsuariosExpatriadosAjustes`);
	}

	ListarTodosResponsablesArea(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarResponsablesArea`);
	}

	ListarResponsablesArea(idDN:string, codArea:string): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarResponsablesArea/${idDN}/${codArea}`);
	}

	ListarPerfiles(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarPerfiles`);
	}

	ListarCostosUsuarios(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarCostosUsuarios`);
	}

	ListarUsuariosDelegado(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarUsuariosDelegado`);
	}

	ListarUsuariosListado(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarUsuariosListado`);
	}

	ListarUsuariosExpatriados(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarUsuariosExpatriados`);
	}

	ListarDelegadosUsuario(dni:string): AxiosPromise<any[]> {
		return this.cliente.post({dni:dni},`/ListarDelegadosUsuario`);
	}

	ListarCentrosCosteUsuario(idEmpleado:number): AxiosPromise<any[]>{
		return this.cliente.get(`/ListarCentrosCosteUsuario/${idEmpleado}`);
	}

	ListarValidadoresAS400Facturador():AxiosPromise<any[]>{
		return this.cliente.get(`/ListarValidadoresAS400Facturador`);
	}

	CrearUsuario(usuario:any): AxiosPromise<any[]> {
		return this.cliente.post(usuario,`/CrearUsuario`);
	}

	EliminarUsuario(dni: string): AxiosPromise<any> {
		return this.cliente.remove(dni, `/EliminarUsuario`);
	}

	ModificarUsuario(dniOld: any,usuario: any): AxiosPromise<any[]> {
		return this.cliente.put(dniOld, usuario, `/ModificarUsuario`);
	}

	ModificarUsuarioExpatriado(usuario: any): AxiosPromise<any[]> {
		return this.cliente.post(usuario, `/ModificarUsuarioExpatriado`);
	}

	ModificarCentrosCosteUsuario(idEmpleado:number,centrosCostes: any): AxiosPromise<any[]> {
		return this.cliente.put(idEmpleado,centrosCostes, `/ModificarCentrosCosteUsuario`);
	}

	GetDatosUsuario(): AxiosPromise<any[]> {
		return this.cliente.get(`/DatosUsuario`);
	}

	GuardarValidadorAS400(validador:any): AxiosPromise<any[]> {
		return this.cliente.post(validador,`/GuardarValidadorAS400`);
	}

	GetPermisosUsuario(dni:string): AxiosPromise<any[]> {
		return this.cliente.post({dni:dni},`/PermisosUsuario`);
	}

	GetPermisosSociedadesExpatriadosUsuario(request:any): AxiosPromise<any[]> {
		return this.cliente.post(request,`/PermisosSociedadesExpatriadosUsuario`);
	}

	GetColumnasUsuario(dni?:string): AxiosPromise<any[]> {
		return this.cliente.post({dni:dni},`/ColumnasUsuario`);
	}

	GetAdjuntosHistoricoUsuarioExpatriado(id:number): AxiosPromise<any[]> {
		return this.cliente.post({idEmpleado:id},`/GetAdjuntosHistoricoUsuarioExpatriado`);
	}

	GetAdjuntosHistoricoPorPais(data:any): AxiosPromise<any[]> {
		return this.cliente.post(data,`/GetAdjuntosHistoricoUsuarioExpatriadoPais`);
	}

	ModificarCosto(usuario: any): AxiosPromise<any[]> {
		return this.cliente.put(usuario.dni, usuario, `/ModificarCosto`);
	}

	AgregarSociedadesUsuario(dni:string,sociedades:string): AxiosPromise<Usuario[]> {
		const data = {dni:dni,sociedades:sociedades}
		return this.cliente.post(data, `/AgregarSociedadesUsuario`);
	}

	AgregarDelegadosUsuario(dni:string,delegados:string): AxiosPromise<Usuario[]> {
		const data = {dni:dni,delegados:delegados}
		return this.cliente.post(data, `/AgregarDelegadosUsuario`);
	}

	AplicarPermisosUsuario(dni:string,dnSel:string,permisos:any): AxiosPromise<any[]> {
		const data = {dni:dni,idDNPermiso:dnSel,permisos:permisos}
		return this.cliente.post(data, `/AplicarPermisosUsuario`);
	}

	AplicarPermisosSociedadesExpatriadosUsuario(dni:string,sociedades:any): AxiosPromise<any[]> {
		const data = {dni:dni,sociedades:sociedades}
		return this.cliente.post(data, `/AplicarPermisosSociedadesExpatriadosUsuario`);
	}

	GuardarColumnasUsuario(columnas:any): AxiosPromise<any[]> {
		const data = {columnas:columnas}
		return this.cliente.post(data, `/GuardarColumnasUsuario`);
	}

	AdjuntarFicherosExpatriado(idEmpleado:number,ficheros:any): Promise<AxiosPromise<any>> {
		var formData = new FormData();

		const Files = ficheros.map((f:any)=>f.file);

		formData.append("IdEmpleado", idEmpleado.toString())
		formData.append("AdjuntosMantener", ficheros.filter((f:any)=> f.idAdjunto!==null).map((m:any)=> m.idAdjunto).join().toString())
		Files.forEach((f: any) => {
			formData.append("Files", f);
		})

		return this.cliente.postFile(formData,`/AdjuntarFicherosExpatriado`)
	}

	AjustesCostosExpatriados(request:any): AxiosPromise<any[]> {
		return this.cliente.post(request,`/AjustesCostosExpatriados`);
	}

	GuardarAjusteCostoExpatriado(request:any): AxiosPromise<any[]> {
		return this.cliente.post(request,`/GuardarAjusteCostoExpatriado`);
	}

	EliminarAjusteCostoExpatriado(request:any): AxiosPromise<any[]> {
		return this.cliente.post(request,`/EliminarAjusteCostoExpatriado`);
	}
}